import L from "leaflet";

const CAL_SVG =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 11h18"/></svg>';

const cache = new Map();

/** Enkelt-maskin-pin. status: overdue|upcoming|ok|none; planned: bool; selected: bool; order: nummer i tur (valfritt). */
export const pinIcon = ({ status, planned, selected, order, active }) => {
  const key = `pin|${status}|${planned ? 1 : 0}|${selected ? 1 : 0}|${order ?? ""}|${active ? 1 : 0}`;
  if (cache.has(key)) return cache.get(key);
  const icon = L.divIcon({
    className: "vms-marker",
    iconSize: [32, 40],
    iconAnchor: [16, 38],
    html:
      `<div class="vms-pin vms-pin--${status || "none"}${selected ? " is-selected" : ""}${active ? " is-active" : ""}" data-testid="map-pin">` +
      `<div class="vms-pin__body"></div>` +
      `<div class="vms-pin__dot">${selected && order ? order : ""}</div>` +
      (planned ? `<div class="vms-pin__badge" title="Planlagt">${CAL_SVG}</div>` : "") +
      `</div>`,
  });
  cache.set(key, icon);
  return icon;
};

/** Klynge (fleire maskiner). */
export const clusterIcon = ({ status, count, planned, selected }) => {
  const key = `cl|${status}|${count}|${planned ? 1 : 0}|${selected ? 1 : 0}`;
  if (cache.has(key)) return cache.get(key);
  const icon = L.divIcon({
    className: "vms-marker-cluster",
    iconSize: [42, 42],
    iconAnchor: [21, 21],
    html:
      `<div class="vms-cluster vms-cluster--${status || "none"}${selected ? " is-selected" : ""}" data-testid="map-cluster">` +
      `<span>${count}</span>` +
      (planned ? `<div class="vms-cluster__badge" title="Planlagt">${CAL_SVG}</div>` : "") +
      `</div>`,
  });
  cache.set(key, icon);
  return icon;
};

export const userIcon = () => {
  if (cache.has("user")) return cache.get("user");
  const icon = L.divIcon({
    className: "vms-marker-user",
    iconSize: [22, 22],
    iconAnchor: [11, 11],
    html: '<div class="vms-user" data-testid="map-user-position"><div class="vms-user__ring"></div><div class="vms-user__dot"></div></div>',
  });
  cache.set("user", icon);
  return icon;
};
